import Cookies from "js-cookie";
import { getPrimaryDomain } from "@/react/helpers/urlHelpers/currentDomain";
import { isCookieSet } from "./isCookieSet";

const COOKIE_OPTIONS = {
  expires: 365, // Cookie expires in 1 year
  path: "/",
  sameSite: "Lax",
} as const;

const getTopLevelDomain = (): string =>
  `.${getPrimaryDomain(window.location.hostname)}`;

export const setFeatureFlagCookie = (
  cookieName: string,
  value: string,
): void => {
  try {
    Cookies.set(cookieName, value, {
      ...COOKIE_OPTIONS,
      domain: getTopLevelDomain(),
    });
  } catch (error) {
    console.error(`Error setting cookie ${cookieName}:`, error);
  }
};

export const getFeatureFlagFromParams = (
  search: string,
  paramName: string,
): string | null => {
  const params = new URLSearchParams(search);
  const paramValue = params.get(paramName);
  return paramValue === "true" || paramValue === "false" ? paramValue : null;
};

export const isFeatureFlagEnabled = (cookieName: string): boolean =>
  isCookieSet(cookieName);
